import React, { useEffect, useState } from 'react';
import { FormData } from '../../apps/AdmarktRegistration/types';

type CreateAccountDialogProps = {
  store: FormData;
  onClose: () => void;
  activeTabId: string;
};

let CreateAccountDialog: React.ComponentType<CreateAccountDialogProps>;

const CreateAccountDialogContainer = ({ store, onClose, activeTabId }: CreateAccountDialogProps) => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const loadComponent = async () => {
      try {
        CreateAccountDialog = (await import(/* webpackChunkName: "createAccountDialog" */ './CreateAccountDialog'))
          .default;
        setIsLoaded(true);
      } catch {
        // continue regardless of error
      }
    };

    loadComponent();
  }, []);

  return isLoaded && <CreateAccountDialog store={store} onClose={onClose} activeTabId={activeTabId} />;
};

export default CreateAccountDialogContainer;
